export const GET_ACCESS_DETAILS = 'GET_ACCESS_DETAILS';
export const GET_PPT_ACCESS_DETAILS = 'GET_PPT_ACCESS_DETAILS';
export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
export const GET_DEFAULT_SETTINGS = 'GET_DEFAULT_SETTINGS';
export const UPDATE_DEFAULT_SETTINGS = 'UPDATE_DEFAULT_SETTINGS';
export const REMOVE_SAVED_TOKEN = '_TOKEN';
export const LANGUAGES_IN_USE = ['1033', '10', '1046', '21', '31748', '32772', '34', '1', '1042', '17'];
